(function () {
    const designWidth = 1920;
    const baseSize = 14;

    function setRem() {
        const width = Math.min(document.documentElement.clientWidth, 1280);
        const fontSize = (width / designWidth) * baseSize;
        document.documentElement.style.fontSize = fontSize + "px";
    }

    setRem();
    window.addEventListener("resize", setRem);
    document.addEventListener("DOMContentLoaded", setRem);
})()